//import Libraries
import React from 'react'
import PropTypes from 'prop-types'

//import Components

import Language from '../../language/language.json';

//import Styles

const categorySelector = ({name, label, options, handleOnChange, value, initialValue, disabled}) => {

    const renderForValue = (<select name={name} onChange={handleOnChange} value={value} disabled={disabled}>
                                {
                                    options !== undefined &&
                                    options.map((option, index) => {
                                       return (
                                            <option value={index} key={index}>{option.text['ko']}</option>
                                        );
                                    })
                                }
                            </select>)

    const renderForDefaultValue = (<select name={name} onChange={handleOnChange} defaultValue={initialValue} disabled={disabled}>
                                {
                                    options !== undefined &&
                                    options.map((option, index) => {
                                        return (
                                            <option value={index} key={index}>{option.text['ko']}</option>
                                        );
                                    })
                                }
                            </select>)

    return (
        <div>
            <label htmlFor={name}>{`${label} : `}</label>
            {
                value === undefined ? renderForDefaultValue : renderForValue
            }
        </div>
    );
}


categorySelector.defaultProps = {
    disabled : false
}

categorySelector.propTypes={
    name : PropTypes.string.isRequired,
    label : PropTypes.string.isRequired,
    options : PropTypes.array,
    handleOnChange : PropTypes.func.isRequired,
}

export default categorySelector;


// WEBPACK FOOTER //
// ./src/components/CategorySelector/CategorySelector.js